import { Component, Input } from '@angular/core';
import { DateFormatPipe } from "@shared/pipes/dateFormatPipe";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ReminderStatus } from '@models/reminders/reminder.enum';
import { ReminderRecord } from '@models/reminders/reminder-record';

type CellRendererParams = ICellRendererParams<ReminderRecord[]>;

@Component({
  selector: 'app-ag-reminder-tag',
  standalone: true,
  imports: [DateFormatPipe],
  templateUrl: 'ag-reminder-tag.component.html',
  styleUrl: 'ag-reminder-tag.component.scss'
})
export class AgReminderTagComponent implements ICellRendererAngularComp  {
  @Input() reminderList: ReminderRecord[] = [];
  ReminderStatus = ReminderStatus;

  readonly tagHeight = 20;
  readonly rowGap = 2;
  readonly maxVisibleRows = 3;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.reminderList = params.value ?? [];
    return true;
  }

  getMaxHeight(): string {
    const rows = Math.min(this.reminderList.length, this.maxVisibleRows);
    const total = rows * this.tagHeight + (rows - 1) * this.rowGap;
    return total + 'px';
  }
}
